import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { callAPI } from "../../helper/apiUtils";
import { requestDirectMessage } from "../../helper/directMessagePrompt";

function UserProfile(props) {
  const history = useHistory();
  const userId = props.match?.params?.id;

  useEffect(() => {
    let active = true;
    (async () => {
      const person = { id: userId };
      try {
        const { data } = await callAPI(`/user/${userId}/profile`, {}, "GET");
        const profile = data?.profile;
        if (profile) {
          person.id = profile.id || userId;
          person.fullName = profile.fullName || `${profile.firstName || ""} ${profile.lastName || ""}`.trim();
          person.firstName = profile.firstName;
          person.lastName = profile.lastName;
          person.avatar = profile.avatar;
        }
      } catch (error) {
        // The prompt still works with the id from the route.
      }
      if (!active) return;
      await requestDirectMessage(person, { replace: true });
      if (!active) return;
      if (window.location.pathname.startsWith("/user-profile/")) {
        if (history.length > 1) history.goBack();
        else history.replace("/messages");
      }
    })();
    return () => {
      active = false;
    };
  }, [userId, history]);

  return null;
}

export default UserProfile;
